import api from './interceptor';

const BASE_URL_V2 = 'api/v2/me';

export default {
  // API Version 2
  getInfo: () => api.get(`${BASE_URL_V2}`),
  setProviderStatus: (data) => api.put(`${BASE_URL_V2}/online`, data),
};
